import { apiBase } from './apiBase';

export const overlayApi = apiBase.injectEndpoints({
  endpoints: (builder) => ({
    getOverlay: builder.query({
      query: (siteId) => `external/overlays?siteId=${siteId}`,
      keepUnusedDataFor: 0.0001,
    }),
  }),
});

export const { useGetOverlayQuery } = overlayApi;
